
<template lang="html">
    <v-container style="padding-top: 100px;">
    <div class="container-fluid">

        <v-row>
            <v-col lg=12 cols=12 style="margin: 0 auto;">
                <v-card>
                    <v-card-title class="pa-5 pb-3 primary">
                        <v-icon class="pr-4" :color="'#FFFFFF'">mdi-upload</v-icon>
                        <p style="color: white;">Carga Layout</p>
                        <v-spacer></v-spacer>
                    </v-card-title>

                    <v-card-text class="pa-5 pt-4">
                        <br />
                        <v-row>
                            <v-col md="6" offset-md="3">
                                <span style="color: black; text-align: center;">Nota:</span>
                                <div>La carga masiva es por flotilla, así que para poder realizar la carga, primero debe seleccionar la flotilla a la que se va a cargar la información.</div>

                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col md="6" offset-md="3">
                                <span style="color: black; text-align: center;">Flotilla:</span>
                                <multiselect v-model="flotillas.flclave"
                                             deselect-label="No se puede remover el valor seleccionado"
                                             selected-label="Seleccionado"
                                             select-label="Seleccione flotilla"
                                             track-by="flclave" label="flnomcorto"
                                             placeholder="Seleccione una opción"
                                             :options="flotillas.opcionesFlotillas"
                                             :disabled="disabledflotillas"
                                             :allow-empty="false">
                                </multiselect>

                                <span v-if="validaflclave" class='spanError' style='color:red;font-size:11px'>Campo requerido</span>
                            </v-col>
                        </v-row>

                        <v-form id="CargaLayout"
                                ref="form"
                                v-model="valid"
                                lazy-validation>
                            <v-row class="mb-6" style="margin-bottom: 0px !important; height: 100px;">
                                <v-col md="6" offset-md="3">

                                    <span style="color: black; text-align: center;">Archivo:</span>
                                    <v-file-input v-model="file"
                                                  @change="onChange"
                                                  color="deep-purple accent-4"
                                                  :rules="rules"
                                                  prepend-icon="mdi-paperclip"
                                                  outlined
                                                  accept=".
                                                  
                                                  
                                                  
                                                  
                                                  
                                                  , .xls"
                                                  required
                                                  :disabled="disabledfile"
                                                  name="file">
                                        <template v-slot:selection="{ index, text }">
                                            <v-chip v-if="index < 2"
                                                    color="deep-purple accent-4"
                                                    dark
                                                    label
                                                    small>
                                                {{ text }}
                                            </v-chip>
                                            <span v-else-if="index === 2"
                                                  class="text-overline grey--text text--darken-3 mx-2">
                                                {{ file.length - 2 }} File(s)
                                            </span>
                                        </template>
                                    </v-file-input>
                                    <!-- <input type="file" @change="onChange1" />-->

                                </v-col>
                            </v-row>
                            <br />
                        </v-form>


                        <v-row justify="center" class="mb-8">
                            <div v-if="!validacargar">
                                <JsonExcel class="btn"
                                           :fetch="fetchData"
                                           :name="`${nombreArchivo}.xls`"
                                           :before-generate="startDownload"
                                           :before-finish="finishDownload">
                                    <v-btn class="ma-2"
                                           color="success"
                                           :disabled="disabledSave">
                                        Descargar Reportes
                                        <v-icon right dark>
                                            mdi-file-excel-outline
                                        </v-icon>
                                    </v-btn>
                                </JsonExcel>
                            </div>
                            <div v-if="validacargar">
                                <v-btn class="ma-2"
                                       color="primary"
                                       @click="GuardarDatos()"
                                       :disabled="disabledSave">
                                    Guardar
                                </v-btn>
                                <v-btn class="ma-2"
                                       @click="reset()"
                                       :disabled="disabledClean">
                                    Limpiar
                                </v-btn>
                            </div>
                        </v-row>
                        <!--<div class="mt-10"><br><br></div>-->

                    </v-card-text>

                    <v-card-text class="pa-1 pt-4" v-if="show">
                        <v-col md="8" offset-md="2">
                            <v-data-table :headers="headers"
                                          :items="datosErrores"
                                          no-data-text="No hay datos disponibles"
                                          :items-per-page="20"
                                          loading-text="Loading... Please wait"
                                          class="elevation-1"
                                          :style="{float: 'none', margin: '0 auto', width: '100%'}"
                                          :footer-props="{
                              'items-per-page-options': [20, 50, 100],
                              'items-per-page-text':'Registros por página'
                            }">
                            </v-data-table>
                        </v-col>
                    </v-card-text>

                </v-card>
            </v-col>
        </v-row>
    </div>

    </v-container>

</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import moment from 'moment';
    import * as XLSX from 'xlsx/xlsx.mjs';
    import cargalayout from '@/services/GestoriaDoc/CargaLayout.service.js';
    import JsonExcel from 'vue-json-excel';

    export default {
        components: {
            JsonExcel
        },
        data() {
            return {
                valid: true,
                file: null,
                data: Array,
                rules: [
                    v => {
                        if (v == null) {
                            return 'Archivo requerido'
                        }
                        else {
                            return true
                        }
                    }

                ],
                disabledSave: false,
                disabledClean:false,
                headers: [
                    { text: 'Fila', value: 'fila', class: "text title" },
                    { text: 'Observaciones', value: 'observaciones', class: "text title" }
                ],
                datosErrores: [],
                show: false,
                flotillas: {
                    opcionesFlotillas: [],
                    flclave: '',
                    flnomcorto: ''
                },
                disabledfile: true,
                validaflclave: false,
                disabledflotillas: false,
                datas: [],
                nombreArchivo: `Reportes_Ventura_${this.$moment().format("YYYY-MM-DD")}`,
                validacargar:true


            }
        },
        watch: {
            async 'flotillas.flclave'(val) {
                this.data = Array;
                this.file = null;
                this.validaflclave = false;
                this.disabledfile = false;

                if (val == '') {
                    this.disabledfile = true;
                }

            }
            

        },


        computed: {
            ...mapGetters(['getUser', 'THEME_STATE']),
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage', 'permission']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            }
        },
        methods: {
            async fetchData() {
                await cargalayout.descargarExcelReportes(this).then(response => {
                    this.datas = response;

                });
                const retorno = this.datas;
                return retorno;
            },
            startDownload() {
                this.$swal({
                    title: 'Procesando solicitud',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    timer: 2000,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });
            },
            finishDownload() {
                
                this.$swal({
                    position: 'center',
                    icon: 'success',
                    title: 'Correcto',
                    text: 'Se descargó correctamente',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.reset();
                        this.disabledSave = false;
                        this.disabledClean = false;
                        this.validacargar = true;
                        this.disabledfile = false;
                        this.disabledflotillas = false;
                    }
                });
            },
            
            onChange(e) {
                this.disabledSave = true;
                this.disabledClean = true;
                
                if (this.file != null) {
                    if (this.file.size > 8500) {
                    var files = e, f = e;
                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = async function (e) {
                        var data = new Uint8Array(e.target.result);

                        var workbook = XLSX.read(data, { type: 'array' });

                        let sheetName = workbook.SheetNames[0];
                      
                        let worksheet = workbook.Sheets[sheetName];
                      

                        //como arreglo
                        //let datos = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 1, defval: ""});

                        let datos = XLSX.utils.sheet_to_json(worksheet, { header: 1}); //2, range: 1 });

                        //vm.data = XLSX.utils.sheet_to_json(worksheet);
                        
                        //vm.data = datos
                        const header = datos.shift();
                       

                        if (header[0] == "Cliente" && header[1] == "SINIESTRO" && header[2] == "F.SINIESTRO" && header[3] == "F. ASIGNACIÓN"
                            && header[4] == "POLIZA" && header[5] == "TIPO DE SINIESTRO" && header[6] == "ESTADO" && header[7] == "MUNICIPIO"
                            && header[8] == "NOMBRE" && header[9] == "PERSONALIDAD" && header[10] == "TELEFONO 1" && header[11] == "TELEFONO 2"
                            && header[12] == "CORREO" && header[13] == "Tipo persona" && header[14] == "MARCA" && header[15] == "MODELO"
                            && header[16] == "AÑO" && header[17] == "SERIE" && header[18] == "COLOR" && header[19] == "PLACA"
                            && header[20] == "En poder de Ventura" && header[21]== "Documentos faltantes") {
                            //vm.archivo = XLSX.utils.sheet_to_json(worksheet);
                            
                            let dat = XLSX.utils.sheet_to_json(worksheet);
                            
                            if (dat.length > 0) {// Correcto para validar la información

                                vm.$swal({
                                    position: 'center',
                                    title: 'Validando Información, espere un momento....',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    didOpen: () => {
                                        vm.$swal.showLoading();
                                    }
                                });
                                
                                vm.data = XLSX.utils.sheet_to_json(worksheet);
                                
                                cargalayout.validardatosExcel(vm).then(response => {
                                    
                                    

                                    setTimeout(() => {
                                        vm.$swal.close();
                                    if (response.length > 0) {
                                        vm.show = true;
                                        vm.datosErrores = response;
                                        vm.disabledClean = false;
                                        vm.disabledfile = true;
                                        vm.disabledflotillas = true;
                                        vm.$swal({
                                            position: 'center',
                                            icon: 'warning',
                                            title: 'Advertencia',
                                            text: 'Verifique los errores de la tabla para poder realizar la carga.',
                                            showConfirmButton: true,
                                            allowOutsideClick: false,
                                            allowEscapeKey: false
                                        })

                                        
                                    }
                                    else {
                                        vm.datosErrores = [];
                                        vm.show = false;
                                        vm.disabledSave = false;
                                        vm.disabledClean = false;
                                    }
                                    }, 1500);

                                });


                                
                            }
                            else {

                                vm.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Formato Incorrecto',
                                    text: 'El archivo no cuenta con algún registro, favor de seleccionar otro',
                                    showConfirmButton: true,
                                    timer: 3000,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        vm.data = Array;
                                        vm.file = null;
                                        vm.reset();
                                        vm.disabledSave = false;
                                        vm.disabledClean = false;
                                    }
                                });
                                setTimeout(() => {
                                    vm.data = Array;
                                    vm.file = null;
                                    vm.reset();
                                    vm.disabledSave = false;
                                    vm.disabledClean = false;
                                }, 3000);
                            }
                            
                           
                            

                        }
                        else {
                            
                            vm.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Formato Incorrecto',
                                text: 'Seleccione otro archivo',
                                showConfirmButton: true,
                                timer: 3000,
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    vm.data = Array;
                                    vm.file = null;
                                    vm.reset();
                                    vm.disabledSave = false;
                                    vm.disabledClean = false;
                                }
                            });
                            setTimeout(() => {
                                vm.data = Array;
                                vm.file = null;
                                vm.reset();
                                vm.disabledSave = false;
                                vm.disabledClean = false;
                            }, 3000);
                        }

                        //var range = XLSX.utils.decode_range(worksheet['!ref']);
                        //var header = this.getHeaderRow(worksheet, range);

                        //range.s.r = 1; // <-- zero-indexed, so setting to 1 will skip row 0
                        //worksheet['!ref'] = XLSX.utils.encode_range(range);
                        //header = this.getHeaderRow(worksheet, range);
                        //range.s.r = 2;
                        //var results = XLSX.utils.sheet_to_json(worksheet, { header: header, range: range, defval: "" });
                        //console.log(results);


                    };
                    reader.readAsArrayBuffer(f);
                    }
                    else {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: 'Formato Incorrecto',
                            text: 'Seleccione otro archivo',
                            showConfirmButton: true,
                            timer: 3000,
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.data = Array;
                                this.file = null;
                                this.reset();
                                this.disabledSave = false;
                                this.disabledClean = false;
                            }
                        });
                        setTimeout(() => {
                            this.data = Array;
                            this.file = null;
                            this.reset();
                            this.disabledSave = false;
                            this.disabledClean = false;
                        }, 3000);
                    }
                }
                else {
                    this.disabledSave = false;
                    this.disabledClean = false;
                    this.data = Array;

                    this.file = null;
                    this.show = false;
                    this.datosErrores = [];
                }
            },
            
            GuardarDatos() {
                
                this.disabledSave = true;
                this.disabledClean = true;
                this.$refs.form.validate();
                

                if (this.$refs.form.validate() && this.flotillas.flclave != '') {
                    
                    this.$swal({
                        position: 'center',
                        title: 'Guardando, espere un momento....',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });

                    cargalayout.datosExcel(this).then(response => {
                        setTimeout(() => {

                            this.$swal.close();
                            if (!response.error) {

                                if (response.data.length > 0) {
                                    this.$swal({
                                        position: 'center',
                                        title: 'Éxito',
                                        text: 'Se guardaron correctamente los registros, espere un momento se hará el envió de los mensajes de texto.',
                                        allowEscapeKey: false,
                                        allowOutsideClick: false,
                                        didOpen: () => {
                                            this.$swal.showLoading();
                                        }
                                    });
                                    setTimeout(() => {
                                        cargalayout.enviosdesms(this, response.data).then(response1 => {
                                            this.$swal.close();
                                            this.$swal({
                                                position: 'center',
                                                title: 'Éxito',
                                                text: 'Se enviaron correctamente los mensajes, espere un momento se hará el envió de los correos.',
                                                allowEscapeKey: false,
                                                allowOutsideClick: false,
                                                didOpen: () => {
                                                    this.$swal.showLoading();
                                                }
                                            });
                                            cargalayout.enviosdecorreos(this, response.data).then(response2 => {
                                                this.$swal.close();

                                                this.$swal({
                                                    position: 'center',
                                                    icon: 'success',
                                                    title: 'Éxito',
                                                    text: 'Se registró la información correctamente, y se hizo el envío de mensajes y correos',
                                                    showConfirmButton: true,
                                                    allowOutsideClick: false,
                                                    allowEscapeKey: false,
                                                }).then((result) => {
                                                    if (result.isConfirmed) {
                                                        //this.reset();
                                                        this.disabledSave = false;
                                                        this.disabledClean = false;
                                                        this.validacargar = false;
                                                        this.disabledfile = true;
                                                        this.disabledflotillas = true;
                                                    }
                                                });
                                            });

                                        });
                                    }, 4000);

                                }
                                else {
                                    this.$swal({
                                        position: 'center',
                                        icon: 'success',
                                        title: 'Éxito',
                                        text: 'Se guardaron correctamente los registros',
                                        showConfirmButton: true,
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            //this.reset();
                                            this.disabledSave = false;
                                            this.disabledClean = false;
                                            this.validacargar = false;
                                            this.disabledfile = true;
                                            this.disabledflotillas = true;
                                        }
                                    });
                                }



                            }
                            else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Error',
                                    text: response.msg,
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        this.reset();
                                        this.disabledSave = false;
                                        this.disabledClean = false;
                                    }
                                })


                            }

                        }, 2000);


                    });


                }
                else {
                    if (this.flotillas.flclave == '') {
                        this.validaflclave = true;
                    }
                    this.disabledSave = false;
                    this.disabledClean = false;
                }
                
                //reader.onload = async function (e) {
                //    console.log(e.target.result);
                //    var data = new Uint8Array(e.target.result);

                //    var workbook = XLSX.read(data, { type: 'array' });

                //    let sheetName = workbook.SheetNames[0]

                //    let worksheet = workbook.Sheets[sheetName];


                //    let datos = XLSX.utils.sheet_to_json(worksheet, { header: 1 })
                //    //this.datos = datos
                //    const header = datos.shift();
                //    console.log(header);

                //};
                //reader.readAsArrayBuffer(f);

            },
            reset() {
                this.datas = [];
                this.data = Array;
                this.file = null;
                this.disabledSave = false;
                this.disabledClean = false;
                this.show = false;
                this.datosErrores = [];
                this.$refs.form.reset();
                this.flotillas.flclave = '';
                this.validaflclave = false;
                this.disabledfile = true;
                this.disabledflotillas = false;
            }


        },
        mounted() {
            cargalayout.obtenerflotillas(this);

        }
    }
</script>

<style>

  
</style>

